import PaymentsList from './list-payments.tsx';

export default function HomeCarePayments() {
  return <PaymentsList type="homecare" title="HomeCare Payments" />;
}
